import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_date_pager = _resolveComponent("date-pager")!
  const _component_class_list = _resolveComponent("class-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_page_title, { value: "クラス日誌" }),
    _createVNode(_component_date_pager, { class: "pt-4" }),
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", null, "クラスを選択", -1)),
      _createVNode(_component_class_list, {
        items: _ctx.classList,
        onClick: _ctx.clickClass
      }, null, 8, ["items", "onClick"])
    ])
  ]))
}